import React from 'react';
import PropTypes from 'prop-types';
import SidePaneDetailsComponent from 'apex-web/lib/components/common/SidePaneDetailsComponent/SidePaneDetailsComponent';
import { formatNumberToLocale } from 'apex-web/lib/helpers/numberFormatter';
import './SendReceiveDetails.css';

class SendReceiveDetailsComponent extends React.Component {
  render() {
    const {
      isSend,
      useExternalAddress,
      balance,
      details: { Amount },
      product: { ProductSymbol },
      TicketAmount,
      fee
    } = this.props;
    const { getItem } = SidePaneDetailsComponent;
    const title = isSend
      ? this.context.t('Send Details')
      : this.context.t('Instructions');
    const amountText = this.context.t('Amount to Send');

    const remainingBalance = formatNumberToLocale(
      balance - (useExternalAddress ? TicketAmount + fee : Amount),
      ProductSymbol
    );
    const classModifiers = isSend ? 'top' : '';
    const isInstructionsForAllCrypto =
      ProductSymbol !== 'TSC' && ProductSymbol !== 'USDC';

    let items = [];
    let info = [];
    let infoHeader = '';

    if (isSend) {
      items.push(
        getItem(
          this.context.t('Your current {ProductSymbol} Balance', {
            ProductSymbol
          }),
          balance
            ? `${formatNumberToLocale(balance, ProductSymbol)} ${ProductSymbol}`
            : '-'
        )
      );
      items.push(
        getItem(
          amountText,
          Amount
            ? `${formatNumberToLocale(
                useExternalAddress ? TicketAmount : Amount,
                ProductSymbol
              )} ${ProductSymbol}`
            : '-'
        )
      );
      items.push(
        getItem(
          this.context.t('Fee'),
          useExternalAddress
            ? `${formatNumberToLocale(fee, ProductSymbol)} ${ProductSymbol}`
            : '-'
        )
      );
      items.push(
        getItem(
          this.context.t(`Remaining Balance`),
          Amount && balance ? `${remainingBalance} ${ProductSymbol}` : '-'
        )
      );
    }

    if (isSend && !useExternalAddress) {
      if (ProductSymbol !== 'USDC') {
        infoHeader = this.context.t('Note');

        info.push(
          `Sending to the wrong network or chain-type address can result in lost funds. For example: only send to a matching network (e.g., Ethereum → Ethereum). When in doubt, always receive a small test amount first.`
        );
        info.push(
          this.context.t(
            'If the sender is not a registered user of Retail, they will receive an email invitation to create an account and claim their funds.'
          )
        );
      }

      if (ProductSymbol == 'USDC') {
        infoHeader = this.context.t('Instructions');
        info.push(
          <div style={{ fontSize: '1.2rem' }}>
            <b>Fund with Fiat</b>
            <div style={{ marginTop: '8px', fontSize: '1.2rem' }}>
              Select <b>ToExternalBaseAddress</b>.
            </div>
          </div>
        );
        info.push(
          'Using the wrong network could result in lost funds. When in doubt, send a small test amount first.'
        );
      }
    }

    if (isSend && useExternalAddress) {
      infoHeader = this.context.t('Instructions');
      if (ProductSymbol === 'TSC') {
        info.push(
          <span>
            Remember to send to your <b>TSC EVM address</b> — it starts with{' '}
            <b>0x</b>.
          </span>
        );
      }

      if (ProductSymbol === 'USDC') {
        info.push(
          <div style={{ fontSize: '1.2rem' }}>
            <b>Fund with Fiat</b>
            <div style={{ marginTop: '8px', fontSize: '1.2rem' }}>
              Select <b>ToExternalBaseAddress</b>.
            </div>
          </div>
        );
        info.push(
          'Using the wrong network could result in lost funds. When in doubt, send a small test amount first.'
        );
      }
    }

    if (
      isSend &&
      useExternalAddress &&
      ProductSymbol !== 'TSC' &&
      ProductSymbol !== 'USDC'
    ) {
      infoHeader = this.context.t('Instructions');
      info.push(
        `Sending to the wrong network or chain-type address can result in lost funds. For example: only send to a matching network (e.g., Ethereum → Ethereum). When in doubt, always receive a small test amount first.`
      );
    }

    if (!isSend && !useExternalAddress) {
      if (ProductSymbol === 'USDC') {
        info.push(
          'Using the wrong network could result in lost funds. When in doubt, receive a small test amount first.'
        );
      }
      if (ProductSymbol !== 'USDC') {
        info.push(
          `Sending to the wrong network or chain-type address can result in lost funds. For example: only send to a matching network (e.g., Ethereum → Ethereum). When in doubt, always receive a small test amount first.`
        );
      }
      info.push(this.context.t('Use this form to request funds via email.'));
      info.push(
        this.context.t(
          'Note - if the requestee is not a registered user of Retail, they will receive an email invitation to create an account.'
        )
      );
    }
    if (!isSend && useExternalAddress) {
      if (ProductSymbol === 'USDC') {
        info.push(
          'Using the wrong network could result in lost funds. When in doubt, receive a small test amount first.'
        );
      }
      if (ProductSymbol !== 'USDC') {
        info.push(
          `Sending to the wrong network or chain-type address can result in lost funds. For example: only send to a matching network (e.g., Ethereum → Ethereum). When in doubt, always receive a small test amount first.`
        );
      }
      info.push(
        this.context.t(
          'Depositing cryptocurrency into your wallet is safe and easy. The address below can always be used to deposit cryptocurrency into your account.'
        )
      );
      info.push(
        this.context.t(
          'Your account will automatically update after the cryptocurrency network confirms your transaction. The confirmation may take up to 1 hour'
        )
      );
    }

    return (
      <SidePaneDetailsComponent
        title={title}
        items={items}
        info={info}
        infoHeader={infoHeader}
        classModifiers={classModifiers}
      />
    );
  }
}

SendReceiveDetailsComponent.propTypes = {
  isSend: PropTypes.bool,
  useExternalAddress: PropTypes.bool,
  details: PropTypes.object,
  fee: PropTypes.number,
  TicketAmount: PropTypes.number
};

SendReceiveDetailsComponent.contextTypes = {
  t: PropTypes.func.isRequired
};

export default SendReceiveDetailsComponent;
